import EarnedPanel from "./EarnedPanel";

export default EarnedPanel;
